import { render, staticRenderFns } from "./EditSMPage.vue?vue&type=template&id=389ab00b&scoped=true&"
import script from "./EditSMPage.vue?vue&type=script&lang=js&"
export * from "./EditSMPage.vue?vue&type=script&lang=js&"
import style0 from "./EditSMPage.vue?vue&type=style&index=0&id=389ab00b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389ab00b",
  null
  
)

export default component.exports